import i18n from "@/libs/i18n";
export default [
  {
    get header() {
      return i18n.t("radiology.radiology");
    },
    permission: "get-radiology",
    role: "Radiology",
  },
  // {
  //   get title() {
  //     return i18n.t("radiology.main-radiology-page");
  //   },
  //   route: "patient-radiology",
  //   permission: "show-patientCardRadiology",
  //   icon: "HomeIcon",
  //   role: "Radiology",
  // },
  {
    get title() {
      return i18n.t("radiology.radiology-dashboard");
    },
    route: "radiology",
    icon: "PlusSquareIcon",
    permission: "get-radiology",
    role: "Radiology",
  },
  {
    get title() {
      return i18n.t("radiology.patients-radiology");
    },
    route: "patient-radiology-list",
    icon: "UsersIcon",
    permission: "get-radiology",
    role: "Radiology",
  },
];
